import { AppBar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "Util/getCustomColor";

export const Root = styled("div")({
  flexGrow: 1,
});

export const AppBarStyled = styled(AppBar)({
  backgroundColor: "#FCFCFD",
  borderBottom: "1px solid rgb(228, 231, 236)",
});

export const BreadcrumbItem = styled("div")<{ hasPointer?: boolean }>(({ hasPointer }) => ({
  cursor: hasPointer ? "pointer" : "default",
}));

export const Container = styled("div")<{
  leftMargin?: number | string;
  rightMargin?: number | string;
}>(({ leftMargin, rightMargin }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  alignItems: "center",
  ...(leftMargin !== undefined
    ? {
        marginLeft: leftMargin,
      }
    : {}),
  ...(rightMargin !== undefined
    ? {
        marginRight: rightMargin,
      }
    : {}),
  transition: "margin-left 0.3s ease, margin-right 0.3s ease, width 0.3s ease",
}));

export const ContainerPageTitle = styled("div")({
  display: "flex",
  flexDirection: "row",
  marginLeft: 8,
});

export const PageTitleText = styled("p")<{ noMargin?: boolean }>(({ noMargin }) => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "20px",
  color: getBrandCustom("primaryColor", "#002445"),
  textOverflow: "ellipsis",
  marginLeft: noMargin ? 0 : "9.5px",
  textTransform: "capitalize",
}));

export const ContainerActions = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-around",
});

export const ContainerActionDumont = styled("div")({
  marginRight: 14,
});
